import Box from '@eversports/klimt-primitives/legacy/Box'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useState } from 'react'

import { Localized } from '../../../../localization/react'
import type { ScheduleSession } from '../../ActivityDetails.types'
import Drawer from '../../components/Drawer'

import ScheduleCardContent from './ScheduleCardContent'

const DEFAULT_CARDS_TO_SHOW = 2

interface Props {
  sessions: Array<ScheduleSession>
  timeZone: string
}

const ScheduleCards = ({ sessions, timeZone }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const togglePopup = () => {
    setIsModalOpen(!isModalOpen)
  }

  const hasMoreCards = sessions.length > DEFAULT_CARDS_TO_SHOW
  const shownMobileSessions = sessions.slice(0, DEFAULT_CARDS_TO_SHOW)

  return (
    <>
      <Stack gap={4} alignItems="center">
        <Stack
          sx={{
            borderTop: '1px solid',
            borderColor: 'mediumgray',
            width: '100%',
          }}
        >
          {shownMobileSessions.map((session) => (
            <ScheduleCardContent key={session.id} session={session} timeZone={timeZone} />
          ))}
        </Stack>
        {hasMoreCards && (
          <Box onClick={togglePopup} sx={{ width: '100%', textAlign: 'center' }}>
            <Text variant="label">
              <Localized id="activity-detail-products-show-more" />
            </Text>
          </Box>
        )}
      </Stack>
      <Drawer isOpen={isModalOpen} handleClose={togglePopup}>
        <Box sx={{ paddingY: 5, background: 'white' }}>
          <Text variant="large" color="midnight" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
            <Localized id="activity-detail-schedule-heading" />
          </Text>
        </Box>
        <Stack alignItems="center" sx={{ overflow: 'scroll', 'div:last-child': { borderBottom: 'none' } }}>
          {sessions.map((session) => (
            <ScheduleCardContent key={session.id} session={session} timeZone={timeZone} />
          ))}
        </Stack>
      </Drawer>
    </>
  )
}

export default ScheduleCards
